module.exports = __webpack_public_path__ + "img/p4.9492770f.jpg";